import type { ReactNode } from "react";
import { ClipboardList, type LucideIcon } from "lucide-react";

type IconProps = {
  className?: string;
};

function SvgIcon({
  className = "h-5 w-5",
  children,
}: IconProps & { children: ReactNode }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {children}
    </svg>
  );
}

export function TabHeartIcon({ className }: IconProps) {
  return (
    <SvgIcon className={className}>
      <path
        d="M7.46819 16.1488L6.9956 16.7312L7.46819 16.1488ZM10.0001 4.64507L9.45225 5.1573C9.59407 5.30898 9.79243 5.39507 10.0001 5.39507C10.2077 5.39507 10.4061 5.30898 10.5479 5.1573L10.0001 4.64507ZM12.532 16.1489L13.0046 16.7312V16.7312L12.532 16.1489ZM10.0001 17.5L10.0001 16.75L10.0001 17.5ZM7.46819 16.1488L7.94078 15.5665C6.7361 14.5889 5.33338 13.31 4.23821 11.9132C3.12858 10.498 2.41675 9.06516 2.41675 7.76455H1.66675H0.916748C0.916748 9.57167 1.87968 11.3361 3.05779 12.8387C4.25036 14.3597 5.74837 15.7191 6.9956 16.7312L7.46819 16.1488ZM1.66675 7.76455H2.41675C2.41675 5.37911 3.45524 3.94003 4.70067 3.45236C5.94265 2.96604 7.71546 3.29978 9.45225 5.1573L10.0001 4.64507L10.5479 4.13284C8.53484 1.97984 6.14098 1.27749 4.15376 2.05562C2.16999 2.8324 0.916748 4.95832 0.916748 7.76455H1.66675ZM12.532 16.1489L13.0046 16.7312C14.2518 15.7191 15.7498 14.3597 16.9424 12.8387C18.1205 11.3362 19.0834 9.57167 19.0834 7.76453H18.3334H17.5834C17.5834 9.06517 16.8716 10.498 15.762 11.9132C14.6668 13.31 13.2641 14.5889 12.0594 15.5665L12.532 16.1489ZM18.3334 7.76453H19.0834C19.0834 4.9583 17.8302 2.83239 15.8464 2.05561C13.8592 1.27749 11.4653 1.97984 9.45225 4.13284L10.0001 4.64507L10.5479 5.1573C12.2847 3.29978 14.0575 2.96604 15.2995 3.45235C16.5449 3.94002 17.5834 5.3791 17.5834 7.76453H18.3334ZM7.46819 16.1488L6.9956 16.7312C8.04504 17.5828 8.81577 18.25 10.0001 18.25L10.0001 17.5L10.0001 16.75C9.45059 16.75 9.11133 16.5164 7.94078 15.5665L7.46819 16.1488ZM12.532 16.1489L12.0594 15.5665C10.8888 16.5164 10.5496 16.75 10.0001 16.75L10.0001 17.5L10.0001 18.25C11.1844 18.25 11.9551 17.5828 13.0046 16.7312L12.532 16.1489Z"
        fill="#02040A"
      />
      <path
        d="M15.4166 7.50002H13.7499M13.7499 7.50002L12.0833 7.50002M13.7499 7.50002L13.7499 5.83334M13.7499 7.50002L13.7499 9.16668"
        stroke="#02040A"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}

const medicalHistoryPaths = (
  <>
    <path
      d="M10 6.66666V9.99999L12.0833 12.0833"
      stroke="#373F51"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.67012 4.67018L4.13979 4.13985L4.13979 4.13985L4.67012 4.67018ZM3.6148 5.72549L2.86481 5.72926C2.86688 6.14053 3.19976 6.47342 3.61103 6.47549L3.6148 5.72549ZM5.73232 6.48615C6.14653 6.48823 6.484 6.15413 6.48608 5.73992C6.48817 5.32572 6.15407 4.98825 5.73986 4.98616L5.73609 5.73616L5.73232 6.48615ZM4.35413 3.60043C4.35205 3.18622 4.01458 2.85213 3.60037 2.85421C3.18616 2.85629 2.85207 3.19376 2.85415 3.60797L3.60414 3.6042L4.35413 3.60043ZM3.31268 9.00447C3.36893 8.59409 3.08185 8.21582 2.67148 8.15957C2.2611 8.10332 1.88283 8.39039 1.82658 8.80077L2.56963 8.90262L3.31268 9.00447ZM15.2766 4.72348L15.8069 4.19315C12.5754 0.961679 7.35187 0.927765 4.13979 4.13985L4.67012 4.67018L5.20045 5.20051C7.81672 2.58424 12.0905 2.59805 14.7463 5.25381L15.2766 4.72348ZM4.72342 15.2766L4.19309 15.807C7.42455 19.0384 12.6481 19.0724 15.8602 15.8603L15.3299 15.3299L14.7996 14.7996C12.1833 17.4159 7.9095 17.4021 5.25375 14.7463L4.72342 15.2766ZM15.3299 15.3299L15.8602 15.8603C19.0723 12.6482 19.0384 7.42462 15.8069 4.19315L15.2766 4.72348L14.7463 5.25381C17.402 7.90956 17.4158 12.1833 14.7996 14.7996L15.3299 15.3299ZM4.67012 4.67018L4.13979 4.13985L3.08447 5.19516L3.6148 5.72549L4.14513 6.25582L5.20045 5.20051L4.67012 4.67018ZM3.6148 5.72549L3.61103 6.47549L5.73232 6.48615L5.73609 5.73616L5.73986 4.98616L3.61857 4.9755L3.6148 5.72549ZM3.6148 5.72549L4.36479 5.72173L4.35413 3.60043L3.60414 3.6042L2.85415 3.60797L2.86481 5.72926L3.6148 5.72549ZM2.56963 8.90262L1.82658 8.80077C1.48693 11.2787 2.27794 13.8918 4.19309 15.807L4.72342 15.2766L5.25375 14.7463C3.68187 13.1744 3.03449 11.034 3.31268 9.00447L2.56963 8.90262Z"
      fill="#373F51"
    />
  </>
);

export function TabMedicalHistoryIcon({ className }: IconProps) {
  return <SvgIcon className={className}>{medicalHistoryPaths}</SvgIcon>;
}

export function TabReportsIcon({ className }: IconProps) {
  return <SvgIcon className={className}>{medicalHistoryPaths}</SvgIcon>;
}

export function TabNotesIcon({ className }: IconProps) {
  return (
    <SvgIcon className={className}>
      <path
        d="M2.5 8.33332C2.5 5.19063 2.5 3.61928 3.47631 2.64297C4.45262 1.66666 6.02397 1.66666 9.16667 1.66666H10.8333C13.976 1.66666 15.5474 1.66666 16.5237 2.64297C17.5 3.61928 17.5 5.19063 17.5 8.33332V11.6667C17.5 14.8094 17.5 16.3807 16.5237 17.357C15.5474 18.3333 13.976 18.3333 10.8333 18.3333H9.16667C6.02397 18.3333 4.45262 18.3333 3.47631 17.357C2.5 16.3807 2.5 14.8094 2.5 11.6667V8.33332Z"
        stroke="#373F51"
        strokeWidth="1.5"
      />
      <path
        d="M9.99992 5L9.99992 6.66667M9.99992 6.66667L9.99992 8.33333M9.99992 6.66667H8.33324M9.99992 6.66667L11.6666 6.66667"
        stroke="#373F51"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.66675 11.6667H13.3334"
        stroke="#373F51"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.5 15L12.5 15"
        stroke="#373F51"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}

export function TabChatIcon({ className }: IconProps) {
  return (
    <SvgIcon className={className}>
      <g clipPath="url(#patient_detail_chat_clip)">
        <path
          d="M8.33341 18.3333C12.0153 18.3333 15.0001 15.3486 15.0001 11.6667C15.0001 7.98477 12.0153 5 8.33341 5C4.65152 5 1.66675 7.98477 1.66675 11.6667C1.66675 12.6963 1.90014 13.6713 2.31691 14.5419C2.46016 14.8411 2.51045 15.1801 2.42471 15.5005L2.15134 16.5222C1.93588 17.3275 2.67259 18.0642 3.47787 17.8487L4.49957 17.5754C4.82003 17.4896 5.159 17.5399 5.45821 17.6832C6.32875 18.0999 7.30383 18.3333 8.33341 18.3333Z"
          stroke="#373F51"
          strokeWidth="1.5"
        />
        <path
          d="M15.0001 12.0849C15.0555 12.0618 15.1104 12.0378 15.1649 12.0129C15.4666 11.8751 15.8051 11.8235 16.1256 11.9093L16.5223 12.0154C17.3276 12.2309 18.0643 11.4941 17.8488 10.6889L17.7427 10.2922C17.6569 9.97171 17.7085 9.63316 17.8463 9.33142C18.1591 8.64665 18.3334 7.88534 18.3334 7.08332C18.3334 4.09178 15.9083 1.66666 12.9167 1.66666C10.6649 1.66666 8.73393 3.04081 7.91675 4.99632"
          stroke="#373F51"
          strokeWidth="1.5"
        />
        <path
          d="M6.24992 11.6667C6.24992 12.1269 5.87682 12.5 5.41659 12.5C4.95635 12.5 4.58325 12.1269 4.58325 11.6667C4.58325 11.2064 4.95635 10.8333 5.41659 10.8333C5.87682 10.8333 6.24992 11.2064 6.24992 11.6667Z"
          fill="#373F51"
        />
        <path
          d="M9.16658 11.6667C9.16658 12.1269 8.79349 12.5 8.33325 12.5C7.87301 12.5 7.49992 12.1269 7.49992 11.6667C7.49992 11.2064 7.87301 10.8333 8.33325 10.8333C8.79349 10.8333 9.16658 11.2064 9.16658 11.6667Z"
          fill="#373F51"
        />
        <path
          d="M12.0833 11.6667C12.0833 12.1269 11.7102 12.5 11.2499 12.5C10.7897 12.5 10.4166 12.1269 10.4166 11.6667C10.4166 11.2064 10.7897 10.8333 11.2499 10.8333C11.7102 10.8333 12.0833 11.2064 12.0833 11.6667Z"
          fill="#373F51"
        />
      </g>
      <defs>
        <clipPath id="patient_detail_chat_clip">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export function HeaderEditIcon({ className }: IconProps) {
  return (
    <SvgIcon className={className}>
      <path
        d="M18.3334 8.75V10C18.3334 13.9284 18.3334 15.8926 17.113 17.1129C15.8926 18.3333 13.9285 18.3333 10.0001 18.3333C6.07171 18.3333 4.10752 18.3333 2.88714 17.1129C1.66675 15.8926 1.66675 13.9284 1.66675 10C1.66675 6.07163 1.66675 4.10745 2.88714 2.88706C4.10752 1.66667 6.07171 1.66667 10.0001 1.66667H11.2501"
        stroke="#222A3D"
        strokeLinecap="round"
      />
      <path
        d="M13.8768 2.87922L14.4175 2.33854C15.3133 1.44271 16.7657 1.44271 17.6615 2.33854C18.5574 3.23437 18.5574 4.68679 17.6615 5.58262L17.1209 6.1233M13.8768 2.87922C13.8768 2.87922 13.9444 4.02817 14.9581 5.04194C15.9719 6.05572 17.1209 6.1233 17.1209 6.1233M13.8768 2.87922L8.90606 7.84995C8.56938 8.18662 8.40105 8.35496 8.25627 8.54058C8.08549 8.75953 7.93908 8.99644 7.81961 9.2471C7.71834 9.4596 7.64306 9.68545 7.49249 10.1372L7.01043 11.5833M7.01043 11.5833L6.69851 12.5191C6.62441 12.7414 6.68227 12.9865 6.84795 13.1521C7.01363 13.3178 7.2587 13.3757 7.48099 13.3016L8.41675 12.9897L9.86294 12.5076C10.3146 12.357 10.5405 12.2817 10.753 12.1805C11.0037 12.061 11.2406 11.9146 11.4595 11.7438C11.6451 11.599 11.8135 11.4307 12.1501 11.094L17.1209 6.1233M8.41675 12.9897L7.01043 11.5833"
        stroke="#222A3D"
      />
    </SvgIcon>
  );
}

export function HeaderAddNoteIcon({ className }: IconProps) {
  return (
    <SvgIcon className={className}>
      <path
        d="M2.5 8.33334C2.5 5.19064 2.5 3.61929 3.47631 2.64298C4.45262 1.66667 6.02397 1.66667 9.16667 1.66667H10.8333C13.976 1.66667 15.5474 1.66667 16.5237 2.64298C17.5 3.61929 17.5 5.19064 17.5 8.33334V11.6667C17.5 14.8094 17.5 16.3807 16.5237 17.357C15.5474 18.3333 13.976 18.3333 10.8333 18.3333H9.16667C6.02397 18.3333 4.45262 18.3333 3.47631 17.357C2.5 16.3807 2.5 14.8094 2.5 11.6667V8.33334Z"
        stroke="#222A3D"
      />
      <path
        d="M9.99992 5L9.99992 6.66667M9.99992 6.66667L9.99992 8.33333M9.99992 6.66667H8.33324M9.99992 6.66667L11.6666 6.66667"
        stroke="#222A3D"
        strokeLinecap="round"
      />
      <path
        d="M6.66675 11.6667H13.3334"
        stroke="#222A3D"
        strokeLinecap="round"
      />
      <path
        d="M7.5 15L12.5 15"
        stroke="#222A3D"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}

export function NoteEditIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g clipPath="url(#note_edit_icon_clip)">
        <path
          d="M18.3332 8.74999V9.99999C18.3332 13.9284 18.3332 15.8925 17.1128 17.1129C15.8924 18.3333 13.9282 18.3333 9.99984 18.3333C6.07147 18.3333 4.10728 18.3333 2.88689 17.1129C1.6665 15.8925 1.6665 13.9284 1.6665 9.99999C1.6665 6.07162 1.6665 4.10743 2.88689 2.88704C4.10728 1.66666 6.07147 1.66666 9.99984 1.66666H11.2498"
          stroke="#373F51"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M13.8765 2.87921L14.4172 2.33853C15.313 1.4427 16.7655 1.4427 17.6613 2.33853C18.5571 3.23435 18.5571 4.68678 17.6613 5.58261L17.1206 6.12329M13.8765 2.87921C13.8765 2.87921 13.9441 4.02815 14.9579 5.04193C15.9717 6.0557 17.1206 6.12329 17.1206 6.12329M13.8765 2.87921L8.90582 7.84993C8.56914 8.18661 8.4008 8.35495 8.25603 8.54056C8.08525 8.75951 7.93883 8.99642 7.81937 9.24709C7.7181 9.45958 7.64281 9.68543 7.49225 10.1371L7.01019 11.5833M7.01019 11.5833L6.69827 12.5191C6.62417 12.7414 6.68202 12.9864 6.84771 13.1521C7.01339 13.3178 7.25846 13.3757 7.48074 13.3016L8.4165 12.9896L9.86269 12.5076C10.3144 12.357 10.5402 12.2817 10.7527 12.1805C11.0034 12.061 11.2403 11.9146 11.4593 11.7438C11.6449 11.599 11.8132 11.4307 12.1499 11.094L17.1206 6.12329M8.4165 12.9896L7.01019 11.5833"
          stroke="#373F51"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="note_edit_icon_clip">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function NoteDeleteIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M12 2.75C11.0215 2.75 10.1871 3.37503 9.87787 4.24993C9.73983 4.64047 9.31134 4.84517 8.9208 4.70713C8.53026 4.56909 8.32557 4.1406 8.46361 3.75007C8.97804 2.29459 10.3661 1.25 12 1.25C13.634 1.25 15.022 2.29459 15.5365 3.75007C15.6745 4.1406 15.4698 4.56909 15.0793 4.70713C14.6887 4.84517 14.2602 4.64047 14.1222 4.24993C13.813 3.37503 12.9785 2.75 12 2.75Z"
        fill="#222A3D"
      />
      <path
        d="M2.75 6C2.75 5.58579 3.08579 5.25 3.5 5.25H20.5001C20.9143 5.25 21.2501 5.58579 21.2501 6C21.2501 6.41421 20.9143 6.75 20.5001 6.75H3.5C3.08579 6.75 2.75 6.41421 2.75 6Z"
        fill="#222A3D"
      />
      <path
        d="M5.91508 8.45011C5.88753 8.03681 5.53015 7.72411 5.11686 7.75166C4.70356 7.77921 4.39085 8.13659 4.41841 8.54989L4.88186 15.5016C4.96735 16.7844 5.03641 17.8205 5.19838 18.6336C5.36678 19.4789 5.6532 20.185 6.2448 20.7384C6.83639 21.2919 7.55994 21.5307 8.41459 21.6425C9.23663 21.75 10.2751 21.75 11.5607 21.75H12.4395C13.7251 21.75 14.7635 21.75 15.5856 21.6425C16.4402 21.5307 17.1638 21.2919 17.7554 20.7384C18.347 20.185 18.6334 19.4789 18.8018 18.6336C18.9637 17.8205 19.0328 16.7844 19.1183 15.5016L19.5818 8.54989C19.6093 8.13659 19.2966 7.77921 18.8833 7.75166C18.47 7.72411 18.1126 8.03681 18.0851 8.45011L17.6251 15.3492C17.5353 16.6971 17.4712 17.6349 17.3307 18.3405C17.1943 19.025 17.004 19.3873 16.7306 19.6431C16.4572 19.8988 16.083 20.0647 15.391 20.1552C14.6776 20.2485 13.7376 20.25 12.3868 20.25H11.6134C10.2626 20.25 9.32255 20.2485 8.60915 20.1552C7.91715 20.0647 7.54299 19.8988 7.26957 19.6431C6.99616 19.3873 6.80583 19.025 6.66948 18.3405C6.52891 17.6349 6.46488 16.6971 6.37503 15.3492L5.91508 8.45011Z"
        fill="#222A3D"
      />
      <path
        d="M9.42546 10.2537C9.83762 10.2125 10.2051 10.5132 10.2464 10.9254L10.7464 15.9254C10.7876 16.3375 10.4869 16.7051 10.0747 16.7463C9.66256 16.7875 9.29502 16.4868 9.25381 16.0746L8.75381 11.0746C8.71259 10.6625 9.0133 10.2949 9.42546 10.2537Z"
        fill="#222A3D"
      />
      <path
        d="M15.2464 11.0746C15.2876 10.6625 14.9869 10.2949 14.5747 10.2537C14.1626 10.2125 13.795 10.5132 13.7538 10.9254L13.2538 15.9254C13.2126 16.3375 13.5133 16.7051 13.9255 16.7463C14.3376 16.7875 14.7051 16.4868 14.7464 16.0746L15.2464 11.0746Z"
        fill="#222A3D"
      />
    </svg>
  );
}

export function AddVitalIcon({ className = "h-5 w-5" }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M10.6667 2.66666C12.1167 2.67473 12.902 2.73903 13.4142 3.25128C14 3.83707 14 4.77988 14 6.6655V10.6655C14 12.5511 14 13.4939 13.4142 14.0797C12.8284 14.6655 11.8856 14.6655 10 14.6655H6C4.11438 14.6655 3.17157 14.6655 2.58579 14.0797C2 13.4939 2 12.5511 2 10.6655V6.6655C2 4.77988 2 3.83707 2.58579 3.25128C3.09804 2.73903 3.88332 2.67473 5.33333 2.66666"
        stroke="currentColor"
      />
      <path
        d="M5.33325 2.33334C5.33325 1.78106 5.78097 1.33334 6.33325 1.33334H9.66659C10.2189 1.33334 10.6666 1.78106 10.6666 2.33334V3.00001C10.6666 3.55229 10.2189 4.00001 9.66659 4.00001H6.33325C5.78097 4.00001 5.33325 3.55229 5.33325 3.00001V2.33334Z"
        stroke="currentColor"
      />
      <path
        d="M10 8.66667L8 8.66667M8 8.66667L6 8.66667M8 8.66667L8 6.66666M8 8.66667L8 10.6667"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function VitalTrendUpIcon({ className = "h-[18px] w-[18px]" }: IconProps) {
  return (
    <svg
      className={`shrink-0 ${className}`}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M7 11L12 6L17 11M12 6V18"
        stroke="#FB7185"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VitalTrendDownIcon({ className = "h-[18px] w-[18px]" }: IconProps) {
  return (
    <svg
      className={`shrink-0 ${className}`}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M7 13L12 18L17 13M12 18V6"
        stroke="#FB7185"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Upload reports icon for Reports tab action button. */
export function UploadReportIcon({ className = "h-5 w-5 shrink-0" }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2.5 12.5C2.5 14.857 2.5 16.0355 3.23223 16.7678C3.96447 17.5 5.14298 17.5 7.5 17.5H12.5C14.857 17.5 16.0355 17.5 16.7678 16.7678C17.5 16.0355 17.5 14.857 17.5 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99984 13.3333V2.5M6.6665 6.14583L9.99984 2.5L13.3332 6.14583"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Dot separator between report type and result in Reports tab rows. */
export function ReportRowSeparator() {
  return (
    <span
      className="h-1.5 w-1.5 shrink-0 rounded-[1.5px] bg-[#9CA3AF]"
      aria-hidden
    />
  );
}

/** ECG report document icon (16×16) for Medical History tab. */
export function EcgReportIcon({
  className = "h-4 w-4 shrink-0 text-blue-600",
}: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M19.3517 7.61665L15.3929 4.05375C14.2651 3.03868 13.7012 2.53114 13.0092 2.26562L13 5.00011C13 7.35713 13 8.53564 13.7322 9.26787C14.4645 10.0001 15.643 10.0001 18 10.0001H21.5801C21.2175 9.29588 20.5684 8.71164 19.3517 7.61665Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14V13.5629C22 12.6901 22 12.0344 21.9574 11.5001H18L17.9051 11.5001C16.808 11.5002 15.8385 11.5003 15.0569 11.3952C14.2098 11.2813 13.3628 11.0198 12.6716 10.3285C11.9803 9.63726 11.7188 8.79028 11.6049 7.94316C11.4998 7.16164 11.4999 6.19207 11.5 5.09497L11.5092 2.26057C11.5095 2.17813 11.5166 2.09659 11.53 2.01666C11.1214 2 10.6358 2 10.0298 2C6.23869 2 4.34315 2 3.17157 3.17157C2 4.34315 2 6.22876 2 10V14C2 17.7712 2 19.6569 3.17157 20.8284C4.34315 22 6.22876 22 10 22ZM7.98704 19.0472C8.27554 19.3176 8.72446 19.3176 9.01296 19.0472L11.013 17.1722C11.3151 16.8889 11.3305 16.4142 11.0472 16.112C10.7639 15.8099 10.2892 15.7945 9.98704 16.0778L9.25 16.7688L9.25 13.5C9.25 13.0858 8.91421 12.75 8.5 12.75C8.08579 12.75 7.75 13.0858 7.75 13.5V16.7688L7.01296 16.0778C6.71077 15.7945 6.23615 15.8099 5.95285 16.112C5.66955 16.4142 5.68486 16.8889 5.98704 17.1722L7.98704 19.0472Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DemographicSeparator() {
  return (
    <span
      className="h-1.5 w-1.5 shrink-0 rounded-[1.5px] bg-[#D1D5DB]"
      aria-hidden
    />
  );
}

export function DemographicRow({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm font-medium text-guardian-body">
      {children}
    </div>
  );
}

export type PatientDetailTabIcon = React.ComponentType<IconProps>;

export const PATIENT_DETAIL_TAB_ICONS: Record<string, PatientDetailTabIcon> = {
  "Health Metrics": TabHeartIcon,
  "Medical History": TabMedicalHistoryIcon,
  Questionnaire: ClipboardList as unknown as PatientDetailTabIcon,
  Reports: TabReportsIcon,
  Notes: TabNotesIcon,
  Chat: TabChatIcon,
};

export function getPatientDetailTabIcon(
  tabId: string
): PatientDetailTabIcon | LucideIcon {
  return PATIENT_DETAIL_TAB_ICONS[tabId] ?? ClipboardList;
}

export type VitalTrendDirection = "up" | "down" | null;

/** Compares latest vs previous chart point; arrows only when reading is abnormal. */
export function getVitalTrend(
  series: (number | null | [number, number])[],
  latest: number,
  isAbnormal: boolean,
  lowSideAbnormal = false
): VitalTrendDirection {
  if (!isAbnormal) return null;

  const values: number[] = [];
  for (const point of series) {
    if (point === null) continue;
    if (Array.isArray(point)) {
      values.push(point[1]);
    } else {
      values.push(point);
    }
  }

  if (values.length < 2) {
    return lowSideAbnormal ? "down" : "up";
  }

  const previous = values[1];
  if (latest > previous) return "up";
  if (latest < previous) return "down";
  return lowSideAbnormal ? "down" : "up";
}

export function VitalTrendIndicator({
  direction,
}: {
  direction: VitalTrendDirection;
}) {
  if (direction === "up") return <VitalTrendUpIcon />;
  if (direction === "down") return <VitalTrendDownIcon />;
  return null;
}
